module.exports = __webpack_public_path__ + "img/exercise-passed-2.8950fa08.png";